
import mergeDeep from "../../../util/mergeDeep.js";
import assign from 'object-assign';

export default class DoelgroepPageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        let context = this.context;
        context.props.loadLayout("Meld nieuwe sportclub");

        context.setState({
            model: context.props.storeModel
        });
    }

    goToNext() {
        this.redirector.goTo("/nieuweSportclub/socialemedia");
    }

    goToPrev() {
        this.redirector.goTo("/nieuweSportclub/sporttak");
    }

    change(event) {
        const value = event.target.checked;
        const context = this.context;
        const state = context.state;

        let model = mergeDeep({}, state.model);
        let doelgroepen = assign([], model.doelgroepen);
        const id = event.target.name.split('_')[1];

        if (doelgroepen.indexOf(id) === -1) {
            doelgroepen.push(id);
        } else {
            doelgroepen.splice(doelgroepen.indexOf(id), 1);
        }

        model.doelgroepen = doelgroepen;

        context.setState({
            model
        });
    }
}